export function AerobicSpeedCalculate(duration,runningIndex,restHrFactor){
    //const runningIndex = localStorage.getItem("runningIndex")
    var factor = 0.857868   ///percent of max (hr/max)
    var x = (factor*1.45)-0.30
    var distanceKm = Math.pow(((x*runningIndex -3.5)/213.9)*duration,1/1.06)
    var speed = (60/duration)*distanceKm
    
    return (speed)
}
export function BaseSpeedCalculate(duration,runningIndex,restHrFactor){
    //const runningIndex = localStorage.getItem("runningIndex")
    var factor = 0.76  ///percent of max (hr/max)
    var x = factor*1.45-0.30
    var distanceKm = Math.pow(((x*runningIndex -3.5)/213.9)*duration,1/1.06)
    var speed = (60/duration)*distanceKm
    return (speed)
}
export function TempoSpeedCalculate(duration,runningIndex,restHrFactor){
    //const runningIndex = localStorage.getItem("runningIndex")
    var factor = 0.895   ///percent of max (hr/max)
    var x = factor*1.45-0.30
    var distanceKm = Math.pow(((x*runningIndex -3.5)/213.9)*duration,1/1.06)
    var speed = (60/duration)*distanceKm
    return (speed)
}
export function IntervalSpeedCalculate(duration,runningIndex){
    //const runningIndex = localStorage.getItem("runningIndex")
    var factor = 1    ///percent of max (hr/max)
    var x = factor*1.45-0.30
    var distanceKm = Math.pow(((x*runningIndex -3.5)/213.9)*duration,1/1.06)
    var speed = (60/duration)*distanceKm
    return (speed)
}





export function GeneralSpeedCalculate(duration,percent,user){
    var restHrFactor = (60 - user.rest_hr)*0.003
    const runningIndex = localStorage.getItem("runningIndex")
    var factor = percent/100 - restHrFactor   ///percent of max (hr/max)
    var x = (factor*1.45)-0.30
    var distanceKm = Math.pow(((x*runningIndex -3.5)/213.9)*duration,1/1.06)
    var speed = (60/duration)*distanceKm
    
    return (speed.toFixed(2))
}